<template>
  <div>
    <div v-if="showloading">
      <loader-sp-vpn />
    </div>
    <div v-else>
      <!--====== PRELOADER PART START ======-->

      <!-- <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>
        <div class="layer layer-three"><span class="overlay"></span></div>
    </div> -->

      <!--====== PRELOADER PART ENDS ======-->

      <!--====== OFFCANVAS MENU PART START ======-->

      <sidebar-home-one
        :sidebar="sidebar"
        @toggleSidebar="toggleSidebar"
        :menuItems="navs"
      />

      <!--====== OFFCANVAS MENU PART ENDS ======-->

      <!--====== PART START ======-->

      <header-home-one @toggleSidebar="toggleSidebar" :menuItems="navs" />

      <!--====== PART ENDS ======-->

      <!--====== sp-vpn HERO PART START ======-->

      <hero-home-one
        welcome_message="Добро пожаловать!"
        slogan="Один сервис на все устройства!"
        description="Находишься заграницей и лагают русские сайты? Подключи РФ сервер и забудь об этом"
        first_button_content="Тарифы"
        first_button_icon="fas fa-tags"
        second_button_content="Перейти в бота"
        second_button_icon="fab fa-telegram"
      />

      <!--====== sp-vpn HERO PART ENDS ======-->

      <!--====== sp-vpn SERVICES PART START ======-->
      <services-home-one
        :grid_items="itemsGrid"
        section_heading="Наши преимущества"
        more_heading=""
        description="Бла бла бла 😁"
      />
      <!--====== sp-vpn SERVICES PART ENDS ======-->

      <!--====== sp-vpn FEATURES PART START ======-->
      <features-home-one />

      <!--====== sp-vpn FEATURES PART ENDS ======-->

      <!--====== sp-vpn PRICING PART START ======-->

      <priceing-home-one
        title="Выбери свой план"
        description="Стандартный план"
      />

      <!--====== sp-vpn PRICING PART ENDS ======-->

      <!--====== sp-vpn FAQ PART START ======-->

      <faq-home-one
        title="FAQ"
      />

      <!--====== sp-vpn FAQ PART ENDS ======-->

      <!--====== sp-vpn FOOTER PART START ======-->

      <footer-home-one />

      <!--====== sp-vpn FOOTER PART ENDS ======-->

      <!--====== sp-vpn BACK TO TOP PART ENDS ======-->
      <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
      </div>
      <!--====== sp-vpn BACK TO TOP PART ENDS ======-->
    </div>
  </div>
</template>
<script>
import blogOne from "@/assets/images/blog-1.jpg";
import blogTwo from "@/assets/images/blog-2.jpg";
import blogThree from "@/assets/images/blog-3.jpg";
import memberOne from "@/assets/images/team-1.jpg";
import memberTwo from "@/assets/images/team-2.jpg";
import memberThree from "@/assets/images/team-3.jpg";
import memberFour from "@/assets/images/team-4.jpg";
import testmonialAvater from "@/assets/images/testimonial-user.png";
import traffic_thumb from "@/assets/images/traffic-thumb.png";
import icon_one from "@/assets/images/icon/5.svg";
import icon_two from "@/assets/images/icon/6.svg";
import icon_three from "@/assets/images/icon/3.png";
import icon_four from "@/assets/images/icon/7.svg";
import HeaderHomeOne from "./HeaderHomeOne.vue";
import SidebarHomeOne from "./SidebarHomeOne.vue";
import HeroHomeOne from "./HeroHomeOne.vue";
import ServicesHomeOne from "./ServicesHomeOne.vue";
import FeaturesHomeOne from "./FeaturesHomeOne.vue";
import PriceingHomeOne from "./PriceingHomeOne.vue";
import FaqHomeOne from "./FaqHomeOne.vue";
import FooterHomeOne from "./FooterHomeOne.vue";
import LoaderSpVpn from "../LoaderSpVpn.vue";
export default {
  name: "HomeOne",
  metaInfo: {
    title: 'Главная'
  },
  props: {
    rtl: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeaderHomeOne,
    SidebarHomeOne,
    HeroHomeOne,
    ServicesHomeOne,
    FeaturesHomeOne,
    PriceingHomeOne,
    FaqHomeOne,
    FooterHomeOne,
    LoaderSpVpn,
  },
  data() {
    return {
      traffic_thumb: traffic_thumb,
      testmonialAvater: testmonialAvater,
      sidebar: false,
      showloading: false,
      navs: [
        {
          name: "Главная",
          path: "/"
        },
        {
          name: "Тарифы",
          path: "/#plans",
        },
        {
          name: "Контакты",
          path: "/#contacts",
        },
        {
          name: "Оферта",
          absPath: 'https://docs.google.com/document/d/1o57HHN41-zzOz4zOB0ZaiY56AQl-kLjJ362vR1QWXVQ/edit',
        },
        // {
        //   name: "news",
        //   childrens: [
        //     {
        //       name: "News",
        //       path: "/news",
        //     },
        //     {
        //       name: "Single news",
        //       path: "/single-news",
        //     },
        //   ],
        // },
      ],
      itemsGrid: [
        {
          count: 1,
          icon: icon_one,
          title: "Неограниченная скорость до 10Gb/s",
          content: "Не ограничиваем вашу скорость!",
          customClass: "",
        },
        {
          count: 2,
          icon: icon_two,
          title: "До 3х устройств одновременно",
          content: "Подключай несколько устройств - плати 1 раз",
          customClass: "item-2",
        },
        {
          count: 3,
          icon: icon_three,
          title: "Надежные и безопасные серверы",
          content: "Не собираем и не продаем ваши данные",
          customClass: "item-3",
        },
        {
          count: 4,
          icon: icon_four,
          title: "Поддержка всех устройств",
          content: "Android, iPhone, Windows, MacOS, Linux",
          customClass: "item-4",
        },
      ],
      features: [
        {
          title: "Carefully designed",
          bg: "", // create class for style
          description: "Mucker plastered bugger all mate morish are.",
        },
        {
          title: "Choose a App",
          bg: "item-2", // create class for style
          description: "Mucker plastered bugger all mate morish are.",
        },
        {
          title: "Seamless Sync",
          bg: "item-3", // create class for style
          description: "Mucker plastered bugger all mate morish are.",
        },
        {
          title: "User Interactive",
          bg: "item-4", // create class for style
          description: "Mucker plastered bugger all mate morish are.",
        },
      ],
      sliderContents: [
        {
          title: "Jason Response",
          date: "April 14, 2022",
          description:
            "Why I say old chap that is spiffing lurgy Oxford cracking goal bleeder, bog-standard Harry brilliant mush a blinding shot starkers.",
          ratings: 5,
          avatar: testmonialAvater,
        },
        {
          title: "Jason Response",
          date: "April 14, 2022",
          description:
            "Why I say old chap that is spiffing lurgy Oxford cracking goal bleeder, bog-standard Harry brilliant mush a blinding shot starkers.",
          ratings: 5,
          avatar: testmonialAvater,
        },
        {
          title: "Jason Response",
          date: "April 14, 2022",
          description:
            "Why I say old chap that is spiffing lurgy Oxford cracking goal bleeder, bog-standard Harry brilliant mush a blinding shot starkers.",
          ratings: 2,
          avatar: testmonialAvater,
        },
        {
          title: "Jason Response",
          date: "April 14, 2022",
          description:
            "Why I say old chap that is spiffing lurgy Oxford cracking goal bleeder, bog-standard Harry brilliant mush a blinding shot starkers.",
          ratings: 3,
          avatar: testmonialAvater,
        },
      ],
      memberOne: memberOne,
      memberTwo: memberTwo,
      memberThree: memberThree,
      memberFour: memberFour,
      members: [
        {
          name: "Benjamin Evalent",
          position: "CEO-Founder",
          img: memberTwo,
          socials: [
            {
              name: "facebok",
              url: "https://www.facebook.com",
              icon: "fab fa-facebook-f", //user font awesome class
            },
            {
              name: "twitter",
              url: "https://www.twitter.com",
              icon: "fab fa-twitter", //user font awesome class
            },
            {
              name: "pinterest",
              url: "https://www.pinterest.com/",
              icon: "fab fa-pinterest-p", //user font awesome class
            },
          ],
        },
        {
          name: "Benjamin Evalent",
          position: "CEO-Founder",
          img: memberOne,
          socials: [
            {
              name: "facebok",
              url: "https://www.facebook.com",
              icon: "fab fa-facebook-f", //user font awesome class
            },
            {
              name: "twitter",
              url: "https://www.twitter.com",
              icon: "fab fa-twitter", //user font awesome class
            },
            {
              name: "pinterest",
              url: "https://www.pinterest.com/",
              icon: "fab fa-pinterest-p", //user font awesome class
            },
          ],
        },
        {
          name: "Benjamin Evalent",
          position: "CEO-Founder",
          img: memberThree,
          socials: [
            {
              name: "facebok",
              url: "https://www.facebook.com",
              icon: "fab fa-facebook-f", //user font awesome class
            },
            {
              name: "pinterest",
              url: "https://www.pinterest.com/",
              icon: "fab fa-pinterest-p", //user font awesome class
            },
          ],
        },
        {
          name: "Benjamin Evalent",
          position: "CEO-Founder",
          img: memberFour,
          socials: [
            {
              name: "facebok",
              url: "https://www.facebook.com",
              icon: "fab fa-facebook-f", //user font awesome class
            },
            {
              name: "twitter",
              url: "https://www.twitter.com",
              icon: "fab fa-twitter", //user font awesome class
            },
            {
              name: "pinterest",
              url: "https://www.pinterest.com/",
              icon: "fab fa-pinterest-p", //user font awesome class
            },
          ],
        },
      ],
      blogOne: blogOne,
      blogTwo: blogTwo,
      blogThree: blogThree,
      blogs: [
        {
          img: blogOne,
          date: "March 10, 2022",
          category: "Saas & App",
          title: "Introducing New Apps Design for our iOS App",
        },
        {
          img: blogTwo,
          date: "March 10, 2022",
          category: "Saas & App",
          title: "How to bring Dolce to your company",
        },
        {
          img: blogThree,
          date: "March 10, 2022",
          category: "Saas & App",
          title: "17 Effective Ways to Monetize Mobile Apps",
        },
      ],
    };
  },
  created() {
    if (!this.rtl) {
      this.preLoading();
    } else {
      this.showloading = false;
    }
    document.addEventListener("scroll", this.topToBottom);
  },

  methods: {
    preLoading() {
      setTimeout(() => {
        this.showloading = false;
      }, 2000);
    },
    topToBottom() {
      const result = document.querySelector(".back-to-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
  },
};
</script>

<style>
</style>
